























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import SuporteEquipamentosStore from '@/components/Suporte/Store/SuporteEquipamentosStore'
import { DataTablePagination } from '@/types/_'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteEquipamentos extends Vue {
  loadEquipamentos: boolean = false
  loadAddEquipamentos: boolean = false
  loadEditEquipamentos: string = ''
  loadGruposEquipamentos: boolean = false
  loadAddGruposEquipamentos: boolean = false
  loadEditGruposEquipamentos: string = ''

  get getSuporteEquipamentosStore() {
    return getModule(SuporteEquipamentosStore, this.$store)
  }

  get paginationGruposEquipamentos() {
    return this.getSuporteEquipamentosStore.paginationGruposEquipamentos
  }

  get paginationEquipamentos() {
    return this.getSuporteEquipamentosStore.paginationEquipamentos
  }

  get loadingEquipamentos() { return this.loadEquipamentos }
  set loadingEquipamentos(value: boolean) { this.loadEquipamentos = value }
  get loadingAddEquipamentos() { return this.loadAddEquipamentos }
  set loadingAddEquipamentos(value: boolean) { this.loadAddEquipamentos = value }
  get loadingEditEquipamentos() { return this.loadEditEquipamentos }
  set loadingEditEquipamentos(value: string) { this.loadEditEquipamentos = value }
  get loadingGruposEquipamentos() { return this.loadGruposEquipamentos }
  set loadingGruposEquipamentos(value: boolean) { this.loadGruposEquipamentos = value }
  get loadingAddGruposEquipamentos() { return this.loadAddGruposEquipamentos }
  set loadingAddGruposEquipamentos(value: boolean) { this.loadAddGruposEquipamentos = value }
  get loadingEditGruposEquipamentos() { return this.loadEditGruposEquipamentos }
  set loadingEditGruposEquipamentos(value: string) { this.loadEditGruposEquipamentos = value }

  get hospitalId() { return this.getSuporteEquipamentosStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteEquipamentosStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get gruposEquipamentosHeaders() {
    return [
      { text: 'Descrição', align: 'left', value: 'nome', sortable: false },
      { text: 'HisId', align: 'left', value: 'hisId', sortable: false },
      { text: 'Somente backoffice?', align: 'center', value: 'exibeApenasParaOBackoffice', sortable: false },
      { text: 'Status', align: 'center', value: 'status', sortable: false },
      { text: 'Ações', align: 'center', value: '', sortable: false },
    ]
  }

  get equipamentosHeaders() {
    return [
      { text: 'Descrição', align: 'left', value: 'nome', sortable: false },
      { text: 'HisId', align: 'left', value: 'hisId', sortable: false },
      { text: 'Quantidade', align: 'left', value: 'quantidade', sortable: false },
      { text: 'Grupo de equipamentos', align: 'left', value: 'grupoEquipamentoId', sortable: false },
      { text: 'Status', align: 'center', value: 'status', sortable: false },
      { text: 'Ações', align: 'center', value: '', sortable: false },
    ]
  }

  get gruposEquipamentos() { return this.getSuporteEquipamentosStore.gruposEquipamentos }
  get gruposDeEquipamentos() { return this.getSuporteEquipamentosStore.gruposDeEquipamentos }
  get equipamentos() { return this.getSuporteEquipamentosStore.equipamentos }
  get searchGrupoEquipamento() { return this.getSuporteEquipamentosStore.searchGrupoEquipamento }
  set searchGrupoEquipamento(value: string) { this.getSuporteEquipamentosStore.setSearchGrupoEquipamento(value) }

  @Watch('searchGrupoEquipamento')
  async onChangeSearchGrupoEquipamento(value: any) {
    this.grupoEquipamentoPagedDebounce({ ...this.paginationGruposEquipamentos })
  }

  get searchEquipamento() { return this.getSuporteEquipamentosStore.searchEquipamento }
  set searchEquipamento(value: string) { this.getSuporteEquipamentosStore.setSearchEquipamento(value) }

  @Watch('searchEquipamento')
  async onChangeSearchEquipamento(value: any) {
    this.equipamentoPagedDebounce({ ...this.paginationEquipamentos })
  }

  async hospitalChange(id: any) {
    this.getSuporteEquipamentosStore.clearSearchGrupoEquipamento()
    this.getSuporteEquipamentosStore.clearSearchEquipamento()
    this.getSuporteEquipamentosStore.setHospitalId(id)

    const params: any = { hospitalId: id }

    this.loadingEquipamentos = true
    await this.getSuporteEquipamentosStore.getEquipamentoPagedSearch({ ...params, ...this.getSuporteEquipamentosStore.paginationEquipDefault })
    this.loadingEquipamentos = false

    this.loadingGruposEquipamentos = true
    await this.getSuporteEquipamentosStore.getGrupoEquipamentoPagedSearch({ ...params, ...this.getSuporteEquipamentosStore.paginationGrupoDefault })
    await this.getSuporteEquipamentosStore.getAllGruposDeEquipamentos()
    this.loadingGruposEquipamentos = false
  }

  equipamentoPagedDebounce = _.debounce(param => this.getSuporteEquipamentosStore.getEquipamentoPagedSearch(param), 700)
  grupoEquipamentoPagedDebounce = _.debounce(param => this.getSuporteEquipamentosStore.getGrupoEquipamentoPagedSearch(param), 700)

  async updatePaginationGruposEquipamentos(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingGruposEquipamentos = true
    this.grupoEquipamentoPagedDebounce(pagination)
    await this.getSuporteEquipamentosStore.getAllGruposDeEquipamentos()
    this.loadingGruposEquipamentos = false
  }

  async updatePaginationEquipamentos(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingEquipamentos = true
    this.equipamentoPagedDebounce(pagination)
    this.loadingEquipamentos = false
  }

  adicionarGrupoEquipamento() {
    this.getSuporteEquipamentosStore.setMode({ modal: 'grupoEquipamento', mode: 'CREATE' })
    this.getSuporteEquipamentosStore.clearGrupoEquipamento()
    this.getSuporteEquipamentosStore.setModal({ name: 'grupoEquipamento', value: true })
  }

  async editarGrupoEquipamento(item: any) {
    this.loadingEditGruposEquipamentos = item.id
    this.getSuporteEquipamentosStore.setMode({ modal: 'grupoEquipamento', mode: 'EDIT' })
    this.getSuporteEquipamentosStore.setGrupoEquipamento({ ...item })
    this.getSuporteEquipamentosStore.setModal({ name: 'grupoEquipamento', value: true })
    this.loadingEditGruposEquipamentos = ''
  }

  adicionarEquipamento() {
    this.getSuporteEquipamentosStore.setMode({ modal: 'equipamento', mode: 'CREATE' })
    this.getSuporteEquipamentosStore.clearEquipamento()
    this.getSuporteEquipamentosStore.setModal({ name: 'equipamento', value: true })
  }

  async editarEquipamento(item: any) {
    this.loadingEditEquipamentos = item.id
    this.getSuporteEquipamentosStore.setMode({ modal: 'equipamento', mode: 'EDIT' })
    this.getSuporteEquipamentosStore.setEquipamento({ ...item })
    this.getSuporteEquipamentosStore.setModal({ name: 'equipamento', value: true })
    this.loadingEditEquipamentos = ''
  }

  getGrupoEquipamentoNome(id: any) {
    if (['', null, undefined].includes(id) || this.gruposDeEquipamentos.length === 0) return ' - '
    const equipamento = this.gruposDeEquipamentos.find((grupoEquipamento: any) => grupoEquipamento.id === id)
    return equipamento ? equipamento.nome : ' - '
  }

  beforeDestroy() {
    this.getSuporteEquipamentosStore.clearGruposDeEquipamentos()
    this.getSuporteEquipamentosStore.clearGruposEquipamentos()
    this.getSuporteEquipamentosStore.clearEquipamentos()
    this.getSuporteEquipamentosStore.clearHospitalId()
  }
}
